module.exports = __webpack_public_path__ + "img/product3.53870074.png";